module.exports = __webpack_public_path__ + "static/media/prague.a9bf9bf5.png";